import React from 'react';
export const FinalCTA = () => {
  return <section id="offer" className="text-lg md:text-xl text-gray-800 mb-12 leading-relaxed space-y-6 border-t border-gray-200 pt-10" data-id="element-84" data-mp="22xshlzwkxkr7">
      <h2 className="font-bold text-2xl md:text-3xl mb-6 text-gray-900" data-id="element-85" data-mp="c7aew89tyci4">
        Stop Waking Up Searching For Relief
      </h2>

      <p data-id="element-86" data-mp="84e3b1ipjgno">
        If your mornings begin with stiffness, discomfort, or frustration,
        continuing to do the same thing is unlikely to produce a different
        result.
      </p>
      <p data-id="element-87" data-mp="h4u42382g9ou">
        The real problem may not be your mattress. It may not even be your
        sleep.
      </p>
      <p data-id="element-88" data-mp="vtgi81lyiveh">
        <strong data-id="element-89" data-mp="vu8ezfraiz6c">
          It may simply be how your neck is being supported every night.
        </strong>
      </p>

      <div className="border border-yellow-200 p-8 rounded-sm my-8 text-center bg-[#CEE0E5]" data-id="element-90" data-mp="qxrq2jc9ogs7">
        <p className="text-2xl font-bold text-gray-900 m-0 mb-4" data-id="element-91" data-mp="14vpuavwviwtz">
          Ready to experience the difference?
        </p>
        <p className="m-0 text-lg mb-8 text-gray-700" data-id="element-92" data-mp="2c4oauvjf355o">
          See why thousands are replacing traditional pillows with VelaSleep
          today.
        </p>
        <a href="https://getvelasleep.com/offer-01-j/?lpid=1156&source_id=DL&utm_source=31299&utm_medium=&utm_term=1156&aff_id=31299&sub_id=&req_id=&oid=1156&device_type=&country_name=&oid=1156&affid=31299" className="inline-block font-bold text-xl py-4 px-10 rounded-full shadow-lg hover:bg-blue-700 hover:shadow-xl transition-all transform hover:-translate-y-1 text-[#000000] bg-[#F5C144]" data-id="element-93" data-mp="2h49irvgkenuj">
          Check Availability Now
        </a>
      </div>
    </section>;
};